




















































import Vue from 'vue'
import Component from 'vue-class-component'
import AuthorizationItemTree from '@/modules/authorization/components/AuthorizationItemTree.vue'
import {Action} from 'vuex-class'
import RoleDetail from '@/modules/authorization/components/RoleDetail.vue'
import LoadingScreen from '@/modules/core/LoadingScreen';
import Role from '@/modules/authorization/model/Role';
import {Colors, notify} from '@/modules/core/notification';
import {util} from 'tinymce';
import Color = util.Color;
import Loader from '@/components/Loader.vue'

/**
 * Pantalla maestra de roles
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: { RoleDetail, AuthorizationItemTree, Loader },
})
export default class RoleMaster extends Vue {
    public $refs: Vue['$refs'] & {
        tree: {
            navigateToNode (path: string): void,
        },
    }

    @Action('authorization/loadFullRoleTree')
    public loadFullRoleTree: () => void

    public loading = true

    public confirmDeleteRole = false
    public removing = false
    public roleToDelete = ''
    public editRoleDialog = false

    public async loadRole (role: Role) {
        this.editRoleDialog = true
        await this.$store.dispatch('authorization/loadRole', role)
    }

    /**
     * Al crear el componente carga el árbol completo de roles de usuario
     */
    public async created () {
        await this.loadFullRoleTree()
        this.loading = false
    }

    public async createRole (path: string) {
        const role = await this.$store.dispatch('authorization/createNewRole', path) as Role
        this.$refs.tree.navigateToNode(role.path)
    }

    public async deleteRole () {
        this.removing = true
        await this.$store.dispatch('authorization/deleteRole', this.roleToDelete)

        this.removing = false
        this.confirmDeleteRole = false

        notify(`El rol ${this.roleToDelete} se ha eliminado correctamente`)
    }

    public errorCaptured (error: Error) {
        this.removing = false
        this.confirmDeleteRole = false
        this.roleToDelete = ''
        notify(error.message, Colors.Error)
    }
}
